var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"pointer",staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/reimbursement/banner.png")},on:{"click":_vm.$login}}),_c('text-left',{attrs:{"text-left":{
      height: 410,
      title: '筝鸣，让费用报销变得简单',
      desc: '办公室，再也不是处理费用报销单的唯一场所。无论何时，无论何地，您都可以在云端完成费用报销单的提交和审核，更加绿色，环保，高效。',
      textWidth: 520,
      imgWidth: 430,
      left: true,
      img: require('@/assets/reimbursement/img1.png')
    }}}),_c('text-left',{attrs:{"text-left":{
      height: 357,
      title: '优化您的费用报销流程',
      desc: '通过提交，审核，追踪所有员工费用报销更好地管理您的内控流程。所有的费用报销信息都在一处显示，只需轻轻一点，便可审核所有的费用报销。',
      textWidth: 540,
      imgWidth: 430,
      left: false,
      img: require('@/assets/reimbursement/img2.png')
    }}}),_c('text-left',{attrs:{"text-left":{
      height: 430,
      title: '报销凭证上传',
      desc: '您的员工长期在外出差吗？费用报销凭证提交不及时怎么办？不用担心，只需用手机拍照并保存为附件上传到系统，就可以作为财务经理进行审核的凭据。',
      textWidth: 520,
      imgWidth: 400,
      left: true,
      img: require('@/assets/reimbursement/img3.png')
    }}}),_c('part-list',{attrs:{"part-list":_vm.list}}),_c('Ready')],1)}
var staticRenderFns = []

export { render, staticRenderFns }